import {
  GraphQLResponseErrors,
  RRNLRequestError,
} from 'react-relay-network-modern'

export const randomQueries = [
  "_id == 'my-specific-id'",
  "_id == 'id1' || _id == 'id2",
  '_id > 100',
  '_id > -10 && _id < 10',
  '_id == false',
  "endsWith(_id, 'Potter')",
  "_id.price > 1500 && _id.currency == 'USD'",
  "_id.color == 'red",
]

export const randomCollections = [
  'movies',
  'characters',
  'cars',
  'colors',
  'media',
  'reviews',
  'products',
  'people',
  'desserts',
  'entrees',
]

function getArrayValueByIndex<T>(index: number, arr: T[]): T {
  if (index < arr.length) {
    return arr[index]
  } else {
    return arr[index % arr.length]
  }
}

export function getRandomCollectionName(index: number) {
  return getArrayValueByIndex(index, randomCollections)
}

export function getRandomQuery(index: number) {
  return getArrayValueByIndex(index, randomQueries)
}

/** Joins all the error messages into one string, using a newline as the separator.
      If `err.res.errors` doesn't exist, it will default to `err.message`. */
export function readableErrorMessage(err: RRNLRequestError) {
  return err.res?.errors?.map((err) => err.message).join('\n') ?? err.message
}

type ErrorWithExtension = GraphQLResponseErrors[number] & {
  extensions: Record<string, string[]>
}
type GraphQLResponseErrorsWithExtensions = Array<ErrorWithExtension>

function isErrorsWithExtension(
  errors?: GraphQLResponseErrors | GraphQLResponseErrorsWithExtensions,
): errors is GraphQLResponseErrorsWithExtensions {
  return (
    errors?.some(
      (err) => (err as ErrorWithExtension).extensions !== undefined,
    ) || false
  )
}

export function readableCreateApiKeyErrorMessage(err: RRNLRequestError) {
  const message = readableErrorMessage(err)

  if (err.res?.errors && isErrorsWithExtension(err.res.errors)) {
    const details = err.res.errors
      .filter((err) => !!err.extensions)
      .map((err) => {
        const extensions = err.extensions
        const read_query_error = extensions.read_query_errors?.join(', ') || ''
        const write_query_error =
          extensions.write_query_errors?.join(', ') || ''

        return [read_query_error, write_query_error].join('\n')
      })
      .join('\n')

    return `${message}:\n${details}`
  }

  return message
}
